module.exports = __webpack_public_path__ + "static/media/Bariol-Light.82b16fd6.woff";